import { Skeleton } from '@mui/material';

import TableBodyCell from 'components/common/Table/TableBodyCell/TableBodyCell';
import TableRow from 'components/common/Table/TableRow/TableRow';

const RolesSkeletonItem = () => {
  return (
    <TableRow isHoverDisabled>
      <TableBodyCell>
        <Skeleton variant="text" width="60%" height={20} />
      </TableBodyCell>
    </TableRow>
  );
};

export default RolesSkeletonItem;
